import React, { useEffect, useRef, useState } from 'react'
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Admin_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { RootState } from '../reducers';
import { useNavigate } from 'react-router-dom';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
export const AdminSickness = () => {

    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('')
    const dispatch = useDispatch();
    const [sickness, setSickness] = useState<[]>([]);
    const getdata = async () => {
        try {
            const payload = { q: 1 };
            const apiname = Admin_API.sickness_API;
            const data = await LoginService.getData(apiname, payload);
            setSickness(data);
        } catch (error) {

        }
    };
    const [specialitylist, setSpeciality] = useState<[]>([]);

    const getSpeciality = async () => {
        try {
            const payload = { q: 2 };
            const apiname = Admin_API.sickness_API;
            const data1 = await LoginService.getData(apiname, payload);
            setSpeciality(data1);
        } catch (error) {

        }
    };
    useEffectOnce(() => {
        getdata()
        getSpeciality()

    }, []);
    const [addDilog, setaddDilog] = useState(false);
    const [sick, setSick] = useState('');
    const [special, setSpecialitylist] = useState('');

    const close = async () => {
        setaddDilog(false);
        setupdateDilog(false);
        setDeleteConfirmation(false);
    }
    const toast = useRef<Toast>(null);

    const add = async () => {
        try {
            const payload = { sick: sick, spec: special, q: 3 };
            const apiname = Admin_API.sickness_API;
            const data1 = await LoginService.getData(apiname, payload);
            if (toast.current) {
                toast.current.show({ severity: 'success', detail: data1 });
            }
            getdata();
            setaddDilog(false);
        } catch (error) {

        }
    };
    const [updateDilog, setupdateDilog] = useState(false);
    const [editData, setEditData] = useState({
        special: '',
        sickness: '',
        sid: '',

    });


    const editupload = (rowData: any) => {
        setEditData({
            special: rowData.SpecilityID,
            sickness: rowData.Sickness,
            sid: rowData.SickID,

        });
        setupdateDilog(true);
    }

    const toast1 = useRef<Toast>(null);
    const editplan = async () => {
        try {
            const { special, sickness, sid } = editData;
            const payload = { spec: special, sick: sickness, sickid: sid, q: 4 };
            const apiname = Admin_API.sickness_API;
            const data = await LoginService.getData(apiname, payload);
            if (toast1.current) {
                toast1.current.show({ severity: 'success', detail: data });
            }
            getdata();
            setupdateDilog(false);
        } catch (error) {

        }
    };
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [removedata, setRemoveData] = useState({
        sid: '',
    });
    const toast2 = useRef<Toast>(null);
    const Removeduring = (rowData: any) => {
        setRemoveData({
            sid: rowData.SickID,
        });
        setDeleteConfirmation(true);
    }

    const confirmDelete = async () => {
        const { sid } = removedata;
        const payload = { sickid: sid, q: 5 };
        const apiname = Admin_API.sickness_API;
        const data = await LoginService.getData(apiname, payload);
        if (toast2.current) {
            toast2.current.show({ severity: 'error', detail: data });
        }
        setDeleteConfirmation(false);
        getdata()
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/adminsickness.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="content-wrapper" style={{ marginLeft: '100px' }}>
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-6">
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content" style={{ marginLeft: '110px' }} >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2" style={{ marginTop: '50px' }}>
                                <h2>Sickness List</h2>
                            </div>
                            <div className="col-16" style={{ textAlign: "right" }}>
                                <a
                                    title="help"
                                    onClick={(e) => openWindow(e, IUrl)}
                                    style={{

                                        color: "blue",
                                        fontSize: 15, cursor: "pointer"
                                    }}
                                >Help for this Page &nbsp;
                                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                </a>
                            </div>

                            <br></br>
                            <div className="card flex flex-wrap justify-content-end" style={{ marginRight: '30px' }}>
                                <Button label="Add Sickness" severity="info" onClick={() => setaddDilog(true)} />
                            </div>
                            <div className="box box-primary">
                                <div className="card">
                                    <p className="m-0">
                                        <div>
                                            <div className="card flex flex-wrap justify-content">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                                                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                                                </span>

                                            </div>
                                            <DataTable value={sickness} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                globalFilterFields={['SpecilityName', 'Sickness', 'Phone', 'Status']} >
                                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                <Column field="SpecilityName" sortable header="Speciality"></Column>
                                                <Column field="Sickness" sortable header="Sickness"></Column>
                                                <Column header="Operation" body={(rowData) => (
                                                    <>

                                                        <Button className='mr-3' tooltip="Edit" severity="info" icon="pi pi-pencil" rounded outlined onClick={() => editupload(rowData)} />
                                                        <Button className='mr-1' tooltip="Delete" severity="danger" icon="pi pi-trash" rounded outlined onClick={() => Removeduring(rowData)} />

                                                    </>
                                                )} />
                                            </DataTable>

                                        </div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Dialog header="Add Sickness" visible={addDilog} style={{ width: '32vw', height: '40vh' }} onHide={() => setaddDilog(false)} >
                <div className="grid pt-1">
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Speciality:</label>
                    </div>
                    <div className="col-6" >
                        <Dropdown
                            id="sickness"
                            value={special}
                            onChange={(e: DropdownChangeEvent) => { setSpecialitylist(e.value); }}
                            options={specialitylist}
                            optionLabel="sname"
                            optionValue="sid"
                            placeholder="Select a Sickness"
                            className="custom-dropdown-placeholder"
                            style={{ width: '15vw', marginLeft: '10px' }}
                        />

                    </div>
                </div>

                <div className="grid pt-3">
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Sickness:</label>
                    </div>
                    <div className="col-6" >
                        <InputText id="amount" style={{ width: '15vw', marginLeft: '10px' }} name="amount" placeholder='Enter Sickness' onChange={(e) => setSick(e.target.value)} />

                    </div>
                </div>


                <Button label="Close" onClick={close} severity="secondary" />
                <Button label="Add" onClick={add} style={{ float: 'right' }} />

            </Dialog >
            <Dialog header="Edit Sickness" visible={updateDilog} style={{ width: '32vw', height: '42vh' }} onHide={() => setupdateDilog(false)} >
                <div className="grid pt-1">
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Speciality:</label>
                    </div>
                    <div className="col-6" >
                        <Dropdown
                            id="sickness"
                            value={editData.special}
                            onChange={(e: DropdownChangeEvent) => setSpecialitylist(e.value)}
                            options={specialitylist}
                            optionLabel="sname"
                            optionValue="sid"
                            placeholder="Select a Sickness"
                            className="custom-dropdown-placeholder"
                            style={{ width: '15vw', marginLeft: '10px' }}
                        />

                    </div>
                </div>

                <div className="grid pt-3">
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Sickness:</label>
                    </div>
                    <div className="col-6" >
                        <InputText id="name" style={{ width: '15vw', marginBottom: '20px', marginLeft: '10px' }} name="Doctitle" onChange={(e) => setEditData({ ...editData, sickness: e.target.value })} value={editData.sickness} />

                    </div>
                </div>


                <Button label="Close" onClick={close} severity="secondary" />
                <Button label="Update" onClick={editplan} style={{ float: 'right' }} />

            </Dialog >
            < Dialog header="Conform Delete " style={{ width: '30vw' }} visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
                <div>Are you really want to Remove...?</div>
                <br></br>
                <Button label="Close" onClick={close} className="mr-3 p-button-secondary" />
                <Button label="Delete" className='mr-3 p-button-raised' onClick={confirmDelete} />
            </Dialog >
            <Toast ref={toast} ></Toast>
            <Toast ref={toast1} ></Toast>
            <Toast ref={toast2} ></Toast>


        </div>)
}
